// removed by extract-text-webpack-plugin
module.exports = {"select":"select__3-d2H"};


//////////////////
// WEBPACK FOOTER
// ./components/Select.css
// module id = bL8V
// module chunks = 2